import React from 'react';
import { createPortal } from 'react-dom';

export class Overlay extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        this.overlayRoot = document.querySelector('#overlay_root');
        this.overlayRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        this.overlayRoot.removeChild(this.el);
    }

    render() {
        return createPortal(
            <div
                style={{
                    position: 'fixed',
                    inset: 0,
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'rgba(0, 0, 0)',
                        opacity: 0.5,
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        overflowY: 'scroll',
                    }}
                    onClick={(e) => {
                        if (e.target === e.currentTarget && this.props.onClick) {
                            this.props.onClick();
                        }
                    }}
                >
                    {this.props.children}
                </div>
            </div>,
            this.el
        );
    }
}
